import { ArchivePage } from "components/Parts/Organisms/ArchivePage";
import { Auth } from "components/Parts/Organisms/Auth";
import React from "react";

export const Archive = React.memo(() => (
  <Auth>
    <ArchivePage />
  </Auth>
));
